import repository from '@/repository'
import { ActionTree, Module, MutationTree } from 'vuex'
import { RootState } from '../types'

const getDefaultState = (): SearchViewState => {
  return {
    locationsAndCameras: [],
    locationsAndCamerasIsLoading: false,
    searchViewIsLoading: false,
    searchViewError: false,
    searchViewErrorMessage: '',
    searchView: [],
  }
}

const state = getDefaultState()

const mutations: MutationTree<SearchViewState> = {
  reset(state) {
    Object.assign(state, getDefaultState())
  },
  setLocationsAndCameras(state, value) {
    state.locationsAndCameras = value
  },
  setLocationsAndCamerasIsLoading(state, value) {
    state.locationsAndCamerasIsLoading = value
  },
  setSearchView(state, value) {
    state.searchView = value
  },
  setSearchViewIsLoading(state, value) {
    state.searchViewIsLoading = value
  },
  setSearchViewError(state, value) {
    state.searchViewError = value
  },
  setSearchViewErrorMessage(state, value) {
    state.searchViewErrorMessage = value
  },
}

const actions: ActionTree<SearchViewState, RootState> = {
  async getLocationsAndCameras({ commit }, payload) {
    commit('setLocationsAndCamerasIsLoading', true)
    return repository.Device.GetLocationDeviceTags(payload)
      .then((res) => {
        commit(
          'setLocationsAndCameras',
          res.data.filter((location) => {
            return location.devices.length > 0
          })
        )
      })
      .finally(() => {
        commit('setLocationsAndCamerasIsLoading', false)
      })
  },
  async startSearch({ commit }, payload) {
    commit('setSearchViewIsLoading', true)
    commit('setSearchViewError', false)
    commit('setSearchView', [])
    return repository.AdvancedVcaEvent.Search(payload)
      .then((res) => {
        commit('setSearchView', res.data)
      })
      .catch((err) => {
        commit('setSearchViewError', true)
        commit(
          'setSearchViewErrorMessage',
          err.response.data.messageLocalizable
        )
      })
      .finally(() => {
        commit('setSearchViewIsLoading', false)
      })
  },
}

const SearchView: Module<SearchViewState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default SearchView

interface SearchViewState {
  locationsAndCameras: any[]
  locationsAndCamerasIsLoading: boolean
  searchViewIsLoading: boolean
  searchViewError: boolean
  searchView: any[]
  searchViewErrorMessage: string
}
